export default {"src":"/_next/static/media/32-icon.a6e260d8.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};